
import { UpdateStandardReturnStateParameter } from "@dana/Services/DanaStandardReturnOrderService";
import { DanaStandardReturnOrderActions } from "@dana/Store/Data/StandardReturns/Reducers/GetStandardReturnOrderReducer";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";


type HandlerType = ApiHandler<UpdateStandardReturnStateParameter,
    DispatchProp<DanaStandardReturnOrderActions>
>;

export const DispatchSetParameters: HandlerType = props => {
    props.dispatch({
        type: "StandardReturn/UpdateFreightCollectInfo",
        freightCollectInfo: props.parameter.freightCollectInfo,
    } as any);
};
export const chain = [DispatchSetParameters];

const updateFreightCollectInfo = createHandlerChainRunner(chain, "UpdateFreightCollectInfoHandler");
export default updateFreightCollectInfo;